<div class='mt--md'>
  <form [formGroup]='providerSettingsForm' novalidate>
    <div class='row pb--md'>
      <div class='column--10'>
        <mat-form-field class="full-width">
          <mat-label>Margin rate (%)</mat-label>
          <mat-icon matSuffix>percent</mat-icon>
          <input id='markupPercentageValue' matInput type="number" formControlName="markupPercentageValue" name='markupPercentageValue' (keyup)="keyPressed($event)" [max]="MAX_MARKUP_PERCENT" [min]="MIN_MARKUP_VALUE" step='1' />
          <mat-error *ngIf="providerSettingsForm.controls['markupPercentageValue'].hasError('min')">
            Minimum allowed margin is {{ MIN_MARKUP_VALUE }}%
          </mat-error>
          <mat-error *ngIf="providerSettingsForm.controls['markupPercentageValue'].hasError('max')">
            Maximum allowed margin is {{ MAX_MARKUP_PERCENT }}%
          </mat-error>
          <mat-hint class='text--xs' align="start">Adjust your cost by adding (or subtracting) a margin to the Machool rate by percentage.</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class='row pb--md'>
      <div class='column--10'>
        <mat-form-field class="full-width">
          <mat-label>Markup rate ($)</mat-label>
          <mat-icon matPrefix>attach_money</mat-icon>
          <input id='markupDollarValue' matInput type="number" formControlName="markupDollarValue" name='markupDollarValue' (keyup)="keyPressed($event)" [max]="MAX_MARKUP_DOLLAR" [min]="MIN_MARKUP_VALUE" step='1' />
          <mat-error *ngIf="providerSettingsForm.controls['markupDollarValue'].hasError('min')">
            Minimum allowed markup is ${{ MIN_MARKUP_VALUE }}
          </mat-error>
          <mat-error *ngIf="providerSettingsForm.controls['markupDollarValue'].hasError('max')">
            Maximum allowed markup is ${{ MAX_MARKUP_DOLLAR }}
          </mat-error>
          <mat-hint class='text--xs' align="start">Adjust your cost by marking up (or absorbing) the Machool rate by a specific $ amount</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class='row pb--md'>
      <div class='column--10'>
        <mat-form-field class="full-width">
          <mat-label>Adjust expected delivery date</mat-label>
          <div matSuffix style="position: relative; bottom: 1px; right: 9px;">days</div>
          <input id='deliveryDate' matInput type="number" formControlName="deliveryDate" name='deliveryDate' (keyup)="keyPressed($event)" max='10' min='0' step='1' />
          <mat-hint class='text--xs' align="start">Adjust the expected delivery date by adding the corresponding amount of business days</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class='row pb--md'>
      <div class='column--10'>
        <mat-form-field class="full-width">
          <mat-label>Fuel Surcharge Rule</mat-label>
          <mat-select formControlName="fuelSurchargeRule">
            <mat-option [value]="'PERCENT'">Percent</mat-option>
            <mat-option [value]="'PER_KILO'">Per Kilo</mat-option>
            <mat-option [value]="'PER_POUND'">Per Pound</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class='row pb--md' *ngIf="showFuelPercent">
      <div class='column--10'>
        <mat-form-field class="full-width">
          <mat-label>Fuel surcharge (%)</mat-label>
          <mat-icon matSuffix>percent</mat-icon>
          <input id='fuelSurchargePercentage' matInput type="number" formControlName="fuelSurchargePercentage" name='fuelSurchargePercentage' (keyup)="keyPressed($event)" [max]="MAX_MARKUP_PERCENT" [min]="MIN_MARKUP_VALUE" step='1' />
          <mat-error *ngIf="providerSettingsForm.controls['fuelSurchargePercentage'].hasError('min')">
            Minimum allowed fuel markup is {{ MIN_MARKUP_VALUE }}%
          </mat-error>
          <mat-error *ngIf="providerSettingsForm.controls['fuelSurchargePercentage'].hasError('max')">
            Maximum allowed fuel markup is {{ MAX_MARKUP_PERCENT }}%
          </mat-error>
          <mat-hint class='text--xs' align="start">Fuel will be surcharged as a percentage of the base cost.</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div class='row pb--md' *ngIf="showFuelWeight">
      <div class='column--10'>
        <mat-form-field class="full-width">
          <mat-label>Fuel surcharge $/{{ isMetric ? 'kg' : 'lb' }}</mat-label>
          <mat-icon matPrefix>attach_money</mat-icon>
          <input id='fuelSurchargePerWeight' matInput type="number" formControlName="fuelSurchargePerWeight" name='fuelSurchargePerWeight' (keyup)="keyPressed($event)" [max]="MAX_MARKUP_DOLLAR" [min]="MIN_MARKUP_VALUE" step='1' />
          <mat-error *ngIf="providerSettingsForm.controls['fuelSurchargePerWeight'].hasError('min')">
            Minimum allowed markup is ${{ MIN_MARKUP_VALUE }}
          </mat-error>
          <mat-error *ngIf="providerSettingsForm.controls['fuelSurchargePerWeight'].hasError('max')">
            Maximum allowed markup is ${{ MAX_MARKUP_DOLLAR }}
          </mat-error>
          <mat-hint class='text--xs' align="start">Fuel will be surcharged per unit of shipment weight.</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="providerHasFuelSurcharges" class='row pb--md'>
      <div class='column--10'>
        <mat-form-field class="full-width">
          <mat-label>Fuel surcharges (%)</mat-label>
          <mat-icon matSuffix>percent</mat-icon>
          <input id='fuelSurchargeMarkupMargin' matInput type="number" formControlName="fuelSurchargeMarkupMargin" name='fuelSurchargeMarkupMargin' (keyup)="keyPressed($event)" max='100' min='0' step='0.01' />
          <mat-hint class='text--xs' align="start">Adjust your cost by marking up (or absorbing) the Machool rate by percentage</mat-hint>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="canEditStatus" class='row pb--md'>
      <div class='column--10'>
        <mat-form-field class="full-width">
          <mat-label>Edit Courier Status</mat-label>
          <mat-select formControlName="enabled">
            <mat-option [value]="true">Enable</mat-option>
            <mat-option [value]="false">Disable</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <ng-container *ngIf="canEditStatus && showAccountTypeSwitches">
      <div class='row pb--md'>
        <div class='column--10'><strong>Account types</strong></div>
      </div>
      <div class='row pb--md'>
        <div class='column--10'>
          <mat-slide-toggle id='maEnabled' formControlName="maEnabled" color="primary">Machool account (MA)</mat-slide-toggle>
          <div class='text--xs'>Companies can rate and ship with Machool's UPS account.</div>
        </div>
      </div>
      <div class='row pb--md'>
        <div class='column--10'>
          <mat-slide-toggle id='byoaEnabled' formControlName="byoaEnabled" color="primary">Your account (BYOA)</mat-slide-toggle>
          <div class='text--xs'>Companies can connect and ship with their own UPS account.</div>
        </div>
      </div>
    </ng-container>
  </form>
</div>

